// Links out to a player's profile on the two sites the club cares about.
//
// One place, because the URL was built inline in four of them and MatchPlay
// moved host. The links pointed at `next.matchplay.events`, a beta subdomain
// that only still works because MatchPlay redirects it to the canonical host.
// Relying on somebody else's redirect is a link that breaks on a day nobody
// chose.
//
// Worth knowing when one of these looks broken: MatchPlay is a single-page app,
// so a bad player id still returns 200 and renders an empty profile. The link
// looks fine and the page looks broken, which is exactly how it was reported.
// The id is what to check first, not the URL.

const MATCHPLAY_HOST = 'https://app.matchplay.events';
const IFPA_HOST = 'https://www.ifpapinball.com';

/**
 * @param {string|number|null|undefined} id MatchPlay user id
 * @returns {string|null} null when there is no id, so callers can hide the link
 */
function matchplayProfileUrl(id) {
  if (id === null || id === undefined || `${id}`.trim() === '') return null;
  return `${MATCHPLAY_HOST}/players/${encodeURIComponent(String(id).trim())}`;
}

/**
 * @param {string|number|null|undefined} id IFPA player id
 * @returns {string|null}
 */
function ifpaProfileUrl(id) {
  if (id === null || id === undefined || `${id}`.trim() === '') return null;
  return `${IFPA_HOST}/player.php?p=${encodeURIComponent(String(id).trim())}`;
}

export { matchplayProfileUrl, ifpaProfileUrl, MATCHPLAY_HOST, IFPA_HOST };
